PaidIntroductionCtrl = ($scope, PayModalService) ->

  $scope.paid = ->
    PayModalService.navigateToPayment()

PaidIntroductionCtrl.$inject = [
  '$scope'
  'PayModalService'
]

module.exports = PaidIntroductionCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/paid-introduction/paid-introduction-controller.coffee